<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.feedailycheck_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/dailycheck/feedailycheck';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        menu: false,
        column: [
          {
            label: '收费主表ID',
            prop: 'id',
            hide: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: '请输入收费主表ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '收费主表ID/退费主表ID',
            prop: 'billId',
            hide: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: '请输入收费主表ID/退费主表ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '交易类型',
            prop: 'bussType',
            hide: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: '请输入交易类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '收费单号/退费单号',
            prop: 'billNo',
            hide: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: '请输入收费单号/退费单号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '缴费日期',
            prop: 'payDate',
            hide: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            search: true,
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            rules: [
              {
                required: true,
                message: '请输入支付时间/退款时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '支付时间',
            prop: 'billTime',
            hide: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: '请输入支付时间/退款时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '房产编码id',
            prop: 'propertyId',
            hide: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: '请输入房产编码id',
                trigger: 'change',
              },
            ],
          },
          {
            label: '地址',
            prop: 'roomName',
            hide: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: '请输入房屋地址信息',
                trigger: 'change',
              },
            ],
          },
          {
            label: '缴费人',
            prop: 'payManId',
            hide: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: '请输入收费人员',
                trigger: 'change',
              },
            ],
          },
          {
            label: '交易金额',
            prop: 'totalPayAmount',
            hide: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: '请输入实收总金额',
                trigger: 'change',
              },
            ],
          },
          {
            label: '支付方式',
            prop: 'payType',
            hide: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            search: true,
            type: 'select',
            dicUrl: 'api/blade-system/dict/dictionary?code=online_type',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [{ required: true, message: '请输入本级属性', trigger: 'change' }],
          },
          {
            label: '结算方式',
            prop: 'balanceType',
            hide: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: '请输入结算方式',
                trigger: 'change',
              },
            ],
          },
          {
            label: '支付结算单号',
            prop: 'paybalanceNo',
            hide: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: '请输入支付结算单号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '结算时间',
            prop: 'balanceTime',
            hide: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: '请输入结算时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '缴费金额',
            prop: 'balanceAmount',
            hide: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: '请输入结算总金额',
                trigger: 'change',
              },
            ],
          },
          {
            label: '对帐状态',
            prop: 'checkStatus',
            hide: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: '请输入对帐状态',
                trigger: 'change',
              },
            ],
          },
          {
            label: '对帐结果',
            prop: 'checkResult',
            hide: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            search: true,
            type: 'select',
            dicUrl: 'api/blade-system/dict/dictionary?code=check_result',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [{ required: true, message: '请输入本级属性', trigger: 'change' }],
          },
          {
            label: '处理员',
            prop: 'dealEmp',
            hide: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: '请输入处理员',
                trigger: 'change',
              },
            ],
          },
          {
            label: '处理时间',
            prop: 'dealTime',
            hide: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: '请输入处理时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '处理动作',
            prop: 'dealType',
            hide: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: '请输入处理动作',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注1',
            prop: 'remark1',
            hide: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: '请输入备注1',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注2',
            prop: 'remark2',
            hide: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: '请输入备注2',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注3',
            prop: 'remark3',
            hide: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: '请输入备注3',
                trigger: 'change',
              },
            ],
          },
          {
            label: '版本',
            prop: 'version',
            hide: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: '请输入版本',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.feedailycheck_add, false),
        viewBtn: this.vaildData(this.permission.feedailycheck_view, false),
        delBtn: this.vaildData(this.permission.feedailycheck_delete, false),
        editBtn: this.vaildData(this.permission.feedailycheck_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
